<template>
  <!-- 头部整体盒子 -->
  <header class="gs18-Header gs18-Header--withme" role="banner" data-js-gs18-header>
    <!-- is-search-open -->
    <div :class="isFixed ? 'is-fixed is-fixed-bottom' : 'is-fixed'">
      <div :class="[openSearch ? 'is-search-open' : '', 'gs18-Header__Inner']">
        <h1 class="gs18-Header__Logo hidden-xs hidden-sm">
          <a href="/"><img src="@/assets/img/home/header/logo3.png" alt="三菱电机上海机电电梯有限公司" /></a>
        </h1>
        <h1 class="gs18-Header__Logo hidden-lg hidden-md">
          <a href="/"><img src="@/assets/img/home/header/logo.png" alt="三菱电机上海机电电梯有限公司" /></a>
        </h1>
        <a :class="[isMobile ? 'gs18-Header__Hamburger is-open-small' : 'gs18-Header__Hamburger']" data-js-gs18-pulldown-open-global-menu @click="showSearch()">
          <img src="/static/assets_gws_template_responsive/default/img/icon/Menu.svg" alt="≡ Open menu.">
        </a>
        <!-- is-hidden -->
        <nav :class="['gs18-HeaderNav', openSearch ? 'is-hidden' : isMobile ? 'is-open-small gs18-HeaderFog' : '']">
          <ul class="gs18-HeaderNav__Menu" :class="isChild ? 'is-step1' : isTwoChild ? 'is-step2' : 'is-step0'">
            <!-- is-step1 -->
            <li class="gs18-HeaderNav__Item text-cursor" v-for="(item, index) in headerList" :key="index" @click="showList(index)">
              <!-- 第一层 -->
              <div class="gs18-HeaderNav__Text" :class="{ 'is-active': index == isActive || index == chooseTitlebagecolor }" data-js-gs18-pulldown-open-menu="" data-js-gs18-pulldown-slide-menu=""
                aria-expanded="false" aria-controls="gs18-GlobalNavList01">{{ item.name }}
              </div>
              <!-- 点击有子元素的,第二层 -->
              <div id="gs18-GlobalNavList01" class="gs18-HeaderPulldown" :class="isChild ? 'is-current-small' : isTwoChild ? 'is-current-small' : ''" v-if="item.children">
                <div class="gs18-HeaderPulldown__Inner">
                  <div class="gs18-HeaderPulldown__Header">
                    <h2 class="gs18-HeaderPulldown__Title">
                      {{ childName }}
                    </h2>
                    <!-- <a class="gs18-HeaderPulldown__Gotop">
                      {{ childName }}
                    </a> -->
                    <a class="gs18-HeaderPulldown__Back" data-js-gs18-pulldown-slide-menu="back" href="#" @click.stop="back()">返回</a>
                  </div>
                  <a class="gs18-HeaderPulldown__Close" data-js-gs18-pulldown-close-menu="">
                    <img src="/ts-common/assets-gs18/common/img/icon/Close.svg" alt="关闭">
                  </a>
                  <ul class="gs18-HeaderPulldown__List">
                    <li class="gs18-HeaderPulldown__ListItem" v-for="(item, index) in childList" :key="index" @click.stop="showChildList(index)">
                      <a data-js-gs18-pulldown-open-sub-menu="" data-js-gs18-pulldown-slide-menu="" aria-expanded="false" aria-controls="gs18-GlobalNavList01-01">{{ item.name }}</a>

                      <!-- 第三层 -->
                      <div class="gs18-HeaderPulldown__Sublist" v-if="item.children" :class="isTwoChild ? 'is-current-small' : ''">
                        <div class="gs18-HeaderPulldown__Header">
                          <h3 class="gs18-HeaderPulldown__Title">{{ twoChildName }}</h3>
                          <a class="gs18-HeaderPulldown__Back" data-js-gs18-pulldown-slide-menu="back" @click.stop="back()">返回</a>
                        </div>
                        <ul class="gs18-HeaderPulldown__List">
                          <li class="gs18-HeaderPulldown__ListItem" v-for="(item, index) in twoChildList" :key="index" @click.stop="showTwoChildList(index)">
                            <a>{{ item.name }}</a>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </nav>
        <!-- /.gs18-Header__Inner -->

        <div class="header-btn" @click="toEn">
          <span>For Overseas Customers</span>
          <i class="el-icon-caret-bottom"></i>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <div class="dialog-box" v-show="dialogVisible" @touchmove.prevent>
      <div class="box">
        <div class="dia-lef">
          <div class="title">{{ dialogObj.name }}</div>
          <div class="goto">
            {{ dialogObj.name }}
          </div>
        </div>
        <div class="dia-right" v-if="dialogObj.children">
          <div class="left">
            <div v-for="(item, index) in dialogObj.children" :key="index" @click="gotoUrl(item)">
              <span>{{ item.name }}</span>
            </div>
          </div>
          <div class="right" v-if="dialogVisibleRight">
            <div v-for="(item, index) in childListRight" :key="index" @click="gotoUrl(item)">
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="colse" @click="closeDialog">
          <img src="../assets/img/Close.svg" alt="">
        </div>
      </div>
    </div>
    <!-- /.gs18-Header -->
  </header>
</template>
<script>
import { WOW } from 'wowjs';
import Information from '../view/contactUs/information.vue';
export default {
  name: "Header2",
  props: {
    isFixed: {
      typeof: Boolean,
      default: false,
    },
    scrollTop: {
      typeof: Number,
      default: 0,
    }
  },
  data() {
    return {
      openSearch: false,
      dialogVisible: false,
      isMobile: false,
      isChild: false,
      isTwoChild: false,
      dialogVisibleRight: false,
      headerList: [
        {
          name: "首页",
          path: "/home",
        },
        {
          name: "关于我们",
          path: "/aboutUs/index",
          children: [
            {
              name: "公司概要",
              path: "/aboutUs/index",
            },
            {
              name: "高质量发展",
              path: "/aboutUs/development",
            },
            {
              name: "企业文化",
              path: "/aboutUs/culture",
            },
            {
              name: "新闻动态",
              path: "/aboutUs/dynamics",
            },
          ],
        },
        {
          name: "产品解决方案",
          path: "",
          children: [
            {
              name: "新建楼宇",
              children: [
                {
                  name: "超高层/超高速",
                  path: "/solution/highSpeed",
                },
                {
                  name: "办公场景",
                  path: "/solution/officeScene",
                },
                {
                  name: "住宅场景",
                  path: "/solution/residence",
                },
                {
                  name: "酒店/商业",
                  path: "/solution/hotel",
                },
                {
                  name: "医院场景",
                  path: "/solution/hospital",
                },
                {
                  name: "通配化装潢",
                  path: "/solution/decorate",
                },
              ],
            },
            {
              name: "私人住宅",
              path: "",
              children: [
                {
                  name: "MAXIEZ-LZ（V）",
                  path: "/solution/MAXIEZ-LZ",
                },
              ]
            },
            {
              name: "更新改造",
              children: [
                {
                  name: "旧梯改造",
                  path: "/solution/renovate",
                },
                {
                  name: "通配化装潢",
                  path: "/solution/decorate",
                },
              ],
            },
            {
              name: "用梯服务",
              path: "",
              children: [
                // {
                //   name: "升级改造",//(运维提升、节能舒适、个性化定制、原厂备件)
                //   path: "/solution/upgrade",
                // },
                {
                  name: "焕新升级",//(运维提升、节能舒适、个性化定制、原厂备件)
                  path: "/solution/renew",
                },
                {
                  name: "原厂备件",//(运维提升、节能舒适、个性化定制、原厂备件)
                  path: "/solution/factory",
                },
                {
                  name: "运行保障",//(运维提升、节能舒适、个性化定制、原厂备件)
                  path: "/solution/guarantee",
                },
              ]
            },
          ],
        },
        {
          name: "智慧服务",
          // path: "",
          children: [
            {
              name: "LNK智慧电梯",
              path: "/service/LNK",
            },
            {
              name: "十年质保",
              path: "/service/warranty",
            },
            {
              name: "CQS定制化服务",
              path: "/service/CQS",
            },
            {
              name: "线上报修",
              path: "/service/guarantee",
            },
          ],
        },
        {
          name: "经典项⽬",
          path: "/typicalprojects",
        },
        {
          name: "联系我们",
          children: [
            {
              name: "联系MESE",
              path: "/contact/address",
            },
            {
              name: "三菱大家庭",
              path: "/contact/family",
            },
            {
              name: "全国服务网点",
              // path: "/contact/qutlets",
              children: [
                {
                  name: "直属分公司",
                  // path: "/contact/company",
                  path: "https://www.smec-cn.com/contact/#contact",
                },
                {
                  name: "维保网点",
                  path: "https://www.smec-cn.com/contact/qutlets#contact",
                  // path: "/contact/qutlets",
                },
                {
                  name: "家用梯体验中心",
                  path: "https://www.smec-cn.com/contact/store",
                  // path: "/contact/store",
                },
              ],
            },
            {
              name: '资料下载',
              path: '',
              children: [
                {
                  name: "产品手册",
                  path: "/contact/catalog",
                },
                {
                  name: "随机资料",
                  path: "/contact/information",
                },
                {
                  name: "土建尺寸",
                  path: "/contact/construction",
                },
                {
                  name: "信息告知",
                  path: "/contact/notice",
                },
              ]
            },
          ],
        },
      ],
      childName: '',
      twoChildName: '',
      childList: [],
      twoChildList: [],
      childListRight: [],
      isActive: -1,
      dialogObj: {},
      businessIntroductionList: [
        "/solution/highSpeed",
        "/solution/officeScene",
        "/solution/machine/MAXIEZ-M/H",
        "/solution/machine/MAXIEZ_LZ",
        "/solution/machine/MAXIEZ_CZ",
        "/solution/machine/MAXIEZ_B",
        "/solution/upgrade",
        "/solution/renovate",
        "/solution/residence",
        "/solution/hotel",
        "/solution/hospital",
        "/solution/decorate",
        "/solution/MAXIEZ-LZ",
        "/solution/nationalSupplement",
        "/solution/renew",
        "/solution/factory",
        "/solution/guarantee",
      ],
      newsinformationList: [
        "/newsinformation/companynews",
        "/newsinformation/industrytrends",
        "/newsinformation/details",
        "/newsinformation/all",
        "/aboutUs/newsInfo",
      ],
      headerShowList: [
        "/home",
        "/newsinformation/companynews",
        "/productinformation",
        "/productapplication",
        "/businessintroduction",
        "/enterpriseinformation",
        "/service",
      ],
      dataList: [
        "/contact/MAXIEZ_BCZ",
        "/contact/MAXIEZ_CZ",
        "/contact/MAXIEZ_LZ_ZQX3",
        "/contact/MAXIEZ_LZ_ZQX4",
        "/contact/MAXIEZ_M",
        "/contact/MAXIEZ_H",
        '/contact/catalog',
        '/contact/information',
        '/contact/construction'
      ]
    }
  },
  mounted() {
    var wow = new WOW();
    wow.init();
  },
  methods: {
    // searchBox() {
    //   this.openSearch = !this.openSearch
    // },
    mouseenter(index) {
      if ('children' in this.headerList[index]) {
        this.dialogVisible = true
        this.dialogObj = this.headerList[index]
      } else {
        this.dialogVisible = false
        return
      }
    },
    mouseleave() {
      this.dialogVisible = false
    },
    //点击展示下拉菜单
    showList(index) {
      this.isActive = index
      this.dialogVisibleRight = false
      //头部点击 显示下拉窗
      if ('children' in this.headerList[index]) {
        // 移动端
        if (this.isMobile) {
          this.isChild = true
          this.childList = this.headerList[index].children
          this.childName = this.headerList[index].name
        } else {
          // pc
          this.dialogVisible = true
          this.dialogObj = this.headerList[index]
          this.isMobile = false
          this.$emit('changeMobile', this.isMobile)
        }
      } else {
        if (this.isMobile) {
          this.isMobile = false
          this.$emit('changeMobile', this.isMobile)
          this.$router.push(this.headerList[index].path).catch(() => { })
        } else {
          this.dialogVisible = false
          this.$router.push(this.headerList[index].path).catch(() => { })
          return
        }
      }
    },
    showChildList(index) {
      if ('children' in this.childList[index]) {
        // 移动端
        if (this.isMobile) {
          this.isTwoChild = true
          this.isChild = false
          this.twoChildList = this.childList[index].children
          this.twoChildName = this.childList[index].name
        }
      } else {
        this.isChild = false
        this.dialogVisible = false
        this.isMobile = false
        this.$emit('changeMobile', this.isMobile)
        if (this.childList[index].path.startsWith('http')) {
          var ua = window.navigator.userAgent.toLowerCase();
          if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            window.location.href = this.childList[index].path
          } else {
            window.open(this.childList[index].path)
            location.reload()
          }
        } else {
          this.$router.push(this.childList[index].path).catch(() => { })
          return
        }
      }

    },
    // 第三层跳转
    showTwoChildList(index) {
      this.isChild = false
      this.isTwoChild = false
      this.dialogVisible = false
      this.isMobile = false
      this.$emit('changeMobile', this.isMobile) //隐藏蒙层
      if (this.twoChildList[index].path.startsWith('http')) {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          window.location.href = this.twoChildList[index].path
        } else {
          window.open(this.twoChildList[index].path)
          location.reload()
        }
      } else {
        this.$router.push(this.twoChildList[index].path).catch(() => { })
        return
      }
    },
    back() {
      if (this.isTwoChild) {
        this.isTwoChild = false
        this.isChild = true
      } else {
        this.isChild = false
        this.isTwoChild = false
      }
      // this.$router.back()
    },
    showdialog() {
      this.dialogVisible = true
    },
    gotoUrl(item) {
      if (item.path) {
        this.dialogVisibleRight = false
        this.dialogVisible = false
        if (item.path.startsWith('http')) {
          window.open(item.path)
        } else {
          this.$router.push(item.path).catch(() => { })
        }
      } else if (item.children) {
        this.dialogVisibleRight = true
        this.childListRight = item.children
      }
    },
    closeDialog() {
      this.dialogVisible = false
      this.isActive = -1
    },

    // 移动端 点击搜索
    showSearch() {
      this.isMobile = !this.isMobile
      // if (this.isMobile) {
      //   this.$refs.searchInput.focus()
      // }
      this.$emit('changeMobile', this.isMobile)
    },
    toEn() {
      this.$router.push('/en/home').catch(() => { })
    },
  },
  computed: {
    chooseTitlebagecolor() {
      let activeIndex = ''
      this.headerList.forEach((item, index) => {
        if (item.path == this.$route.path) {
          this.isActive = index
          activeIndex = index
        }
        if (item.children) {
          item.children.forEach(item => {
            if (item.path == this.$route.path) {
              this.isActive = index
              activeIndex = index
            }
          })
        }
      });
      this.businessIntroductionList.forEach(item => {
        if (item == this.$route.path) {
          this.isActive = 2
          activeIndex = 2
        }
      })
      this.newsinformationList.forEach(item => {
        if (item == this.$route.path) {
          this.isActive = 1
          activeIndex = 1
        }
      })
      this.headerShowList.forEach((item, index) => {
        if (item == this.$route.path) {
          this.isActive = index
          activeIndex = index
        }
      })
      this.dataList.forEach((item, index) => {
        if (item == this.$route.path) {
          this.isActive = 5
          activeIndex = 5
        }
      })
      if (!activeIndex) {
        activeIndex = -1
      }
      return activeIndex
    }
  }
}

</script>

<style scoped>
.is-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  background-color: #fff;
}

.is-fixed::after {
  content: '';
  clear: both;
  display: block;
}

.is-fixed-bottom {
  /* border-bottom: 1px solid #cccccc; */
  box-shadow: 0px 10px 10px -10px #cccccc;
}

.is-active {
  color: #f50f10;
}

.text-cursor {
  cursor: pointer;
}

/* 弹窗 */
.dialog-box {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 19;
}


.dialog-box .box {
  position: absolute;
  background: #f6f6f6;
  left: 0;
  top: 85px;
  right: 0;
  margin: auto;
  font-size: 18px;
  max-width: 1380px;
  display: flex;
}

.dialog-box .box .dia-lef {
  box-sizing: border-box;
  display: table-cell;
  padding: 75px 0 30px 30px;
  flex: 1;
}

.dialog-box .box .dia-lef .title {
  margin: 0 0 40px;
  font-size: 36px;
  font-weight: 700;
  line-height: 1;
  color: #000;
}

.dialog-box .box .dia-lef .goto {
  box-sizing: border-box;
  display: table-cell;
  vertical-align: middle;
  padding: 0 15px;
  width: 280px;
  height: 50px;
  background: url('../assets/img/ArrowNext.svg') no-repeat right 15px center;
  background-size: 36px auto;
  border: solid 2px;
  color: #000;
  font-size: 18px;
  font-weight: 700;
  text-decoration: none;
  transition: .2s background, .2s border-color, .2s color;
}

.dialog-box .box .dia-right {
  flex: 2;
  position: relative;
  list-style: none;
  vertical-align: top;
  display: flex;
}

.dialog-box .box .dia-right div {
  flex: 1;
}

.dialog-box .box .dia-right .left {
  padding: 70px 0 30px;
}

.dialog-box .box .dia-right .right {
  padding: 70px 0 30px 30px;
  background-color: #e1e1e1;
}

.dialog-box .box .dia-right .left div {
  margin-bottom: 10px;
  font-weight: bold;
  cursor: pointer;
  flex: 1;
  display: flex;
  align-items: center;
}

.dialog-box .box .dia-right .left img {
  width: 26px;
  color: blue;
}

.dialog-box .box .dia-right .left span {
  /* width: 26px;
  color: blue; */
  margin-left: 10px;
}

.dialog-box .box .dia-right .right div {
  margin-bottom: 10px;
  font-weight: bold;
  cursor: pointer;
  flex: 1;
}

.dialog-box .box .dia-right .left div:hover {
  color: #f50f10;
}

.dialog-box .box .dia-right .right div:hover {
  color: #f50f10;
}

.dialog-box .box .dia-right .right div:hover img {
  color: #f50f10;
}

.dialog-box .colse {
  position: absolute;
  top: 30px;
  right: 30px;
  z-index: 3;
  cursor: pointer;
  width: 26px;
  height: 26px;
}

.dialog-box .colse img {
  vertical-align: middle;
}

.dialog-box .colse img:hover {
  background: url('../assets/img/Close-R.svg') no-repeat -100% -100%;
}

.dialog-box .colse img:hover img {
  display: none;
}

.header-btn {
  position: absolute;
  right: 0%;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;

  i {
    margin-left: -6px;
  }

  &:hover {
    color: #f50f10;
  }
}

@media only screen and (max-width: 1600px) {
  .header-btn {
    right: 0px;
    font-size: 16px;
    font-weight: 500;
  }
}

@media only screen and (max-width: 1300px) {
  .header-btn {
    position: absolute;
    right: 0%;
    font-size: 15px;

    span {
      display: inline-block;
      width: 100px;
    }
  }
}


@media only screen and (max-width: 1200px) {
  .header-btn {
    position: absolute;
    right: 0%;
    font-size: 14px;
    font-weight: 400;

    span {
      width: 86px;
    }
  }
}
@media only screen and (max-width: 1100px) {
  .header-btn {
    position: absolute;
    right: 0%;
    font-size: 12px;
    font-weight: 400;

    span {
      width: 76px;
    }
  }
}

@media only screen and (max-width: 980px) {
  .header-btn {
    position: absolute;
    right: 14%;
    font-size: 12px;
    font-weight: 400;

    span {
      display: inline;
    }

    i {
      margin-left: -0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header2.vue